<div
  class="dropdown-container"
  (click)="onContainerClick($event)"
  tabindex="0"
  (keydown.enter)="onContainerClick($event)"
>
  <div
    class="dropdown-display"
    (click)="toggleDropdown($event)"
    tabindex="0"
    (keydown.enter)="toggleDropdown($event)"
  >
    <div class="dropdown-placeholder-wrapper">
      <!-- This <label> is for accessibility and visual structure -->
      <span class="dropdown-label" [class.floating]="selectedItem?.key">
        {{ placeHolder || 'Filter' }}
      </span>
      <span class="dropdown-selected">
        {{ selectedItem?.key || '' }}
        <button
          *ngIf="selectedItem"
          class="clear-btn"
          type="button"
          (click)="clearSelection($event)"
          aria-label="Clear selection"
        >
          <mat-icon>close</mat-icon>
        </button>
      </span>
    </div>
    <button class="dropdown-arrow-btn">
      <!-- <i class="fa-solid fa-caret-down"></i> -->
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
  </div>

  @if (dropdownVisible) {
    <div class="dropdown-list">
      <div class="search-bar">
        <div [formGroup]="searchForm" class="search-input-container">
          <input
            type="search"
            placeholder="Search and Press Enter"
            formControlName="searchInput"
            (keydown.enter)="onEnterPress($event)"
            required
          />
        </div>
      </div>

      <div class="list-items">
        @if (filteredItems.length > 0) {
          <ul>
            @for (item of filteredItems; track item) {
              <li
                (click)="onItemSelect(item)"
                tabindex="0"
                (keydown.enter)="onItemSelect(item)"
                class="list-item"
              >
                {{ item.key }}
              </li>
            }
          </ul>
        } @else {
          <img
            loading="lazy"
            class="no-data-img"
            src="../../assets/dataNotFound.jpg"
            alt="No Data Found"
          />
        }
      </div>
    </div>
  }
</div>
